// extracted by mini-css-extract-plugin
export var columnList = "_k1-0";